'use client'

import { useDocumentInfo } from '@payloadcms/ui'

import { PrdPanelClient } from './PrdPanelClient.jsx'

// Mounted as a UI field at the top of the Projects edit form (see
// src/collections/Projects.ts `prdPanel`), so the panel renders as a
// full-width in-flow admin card in the main column — the same visual slot
// the deal-desk panels (GenerateOfferPanel/InviteFounderPanel) occupy above
// their list tables. (The original mount, admin.components.edit.
// beforeDocumentControls, renders inside the document-controls corner and
// floated the panel over the page header and Save button.) Reads the
// project id from the edit view's document context; on the create view
// (no id yet) there is nothing to show.
export function PrdPanel() {
  const { id } = useDocumentInfo()
  if (!id) return null
  return <PrdPanelClient projectId={id} />
}
